module.exports = __webpack_public_path__ + "media/66.cab97498.wav";